'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { UnmappedValidationErrorModal } from '@app/_components/error/customErrorModals/UnmappedValidationErrorModal';
import { customValidationException } from '@app/_components/error/CustomValidationException';
import { Modal } from '@endurancewarranty/ui';
import { customErrorAtom } from '@states/customError/customErrorAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
import type { ICustomValidationExceptionMetadata } from '@app/_components/error/CustomValidationException';
import type { FC, ReactNode } from 'react';
export const CustomErrorModal: FC = () => {
  const $ = _c(14);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useJotaiAtom(customErrorAtom);
  let t0;
  if ($[0] !== setError) {
    t0 = () => {
      setError(_temp);
      setIsOpen(false);
    };
    $[0] = setError;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClose = t0;
  let t1;
  let t2;
  if ($[2] !== error.error) {
    t1 = () => {
      if (error.error != null) {
        setIsOpen(true);
      }
    };
    t2 = [error.error];
    $[2] = error.error;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== error.error || $[6] !== onClose) {
    t3 = () => {
      if (error.error == null) {
        return null;
      }
      const {
        errorType,
        description,
        parameters
      } = error.error.customValidationException;
      const metadata = customValidationException[errorType];
      if (metadata == null) {
        return <UnmappedValidationErrorModal description={description} onClose={onClose} />;
      }
      return metadata.component(onClose, parameters);
    };
    $[5] = error.error;
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const renderError = t3;
  let t4;
  if ($[8] !== renderError) {
    t4 = renderError();
    $[8] = renderError;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isOpen || $[11] !== onClose || $[12] !== t4) {
    t5 = <Modal className="w-[400px]" isOpen={isOpen} onClose={onClose} hasCloseButton={false}>{t4}</Modal>;
    $[10] = isOpen;
    $[11] = onClose;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(previous) {
  return {
    ...previous,
    error: null
  };
}